import script from "./logCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./logCard.vue?vue&type=script&setup=true&lang=ts"

import "./logCard.vue?vue&type=style&index=0&id=274058b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274058b2"]])

export default __exports__